import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";

function initLibrary() {
  const librarySec = document.querySelector(".page-library");
  if (!librarySec) return;

  // Initialize Fancybox for gallery items on page load
  Fancybox.bind('[data-fancybox="gallery-library"]', {
    groupAll: false,
  });

  const pageId = librarySec.dataset.pageId;
  const tabs = librarySec.querySelectorAll(".library-tabs .tab-item");
  const resultsContainer = document.getElementById("library-results");
  const loadMoreBtn = document.getElementById("library-load-more");

  if (!tabs.length || !resultsContainer || !loadMoreBtn) return;

  // Active tab track
  let activeTabId = "all";

  // Tab click event
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      if (this.classList.contains("active")) return;

      tabs.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      activeTabId = this.dataset.tab;

      // Reset loading offset and show loader
      loadMoreBtn.classList.add("hidden");
      resultsContainer.innerHTML =
        '<div class="library-loading"><div class="spinner"></div><span>Đang tải hình ảnh...</span></div>';

      fetchLibraryImages(activeTabId, 0, (response) => {
        if (response.success && response.data.html) {
          resultsContainer.innerHTML = response.data.html;

          // Re-bind Fancybox
          Fancybox.bind('[data-fancybox="gallery-library"]', {
            groupAll: false,
          });

          // Show/Hide Load More Button
          if (response.data.has_more) {
            loadMoreBtn.classList.remove("hidden");
            loadMoreBtn.dataset.offset = 18;
          } else {
            loadMoreBtn.classList.add("hidden");
          }
        } else {
          resultsContainer.innerHTML =
            '<div class="library-empty text-center"><p>Không tìm thấy hình ảnh nào</p></div>';
        }
      });
    });
  });

  // Load More click event
  loadMoreBtn.addEventListener("click", function () {
    const offset = parseInt(this.dataset.offset) || 0;
    this.disabled = true;
    const btnText = this.querySelector("span");
    const originalText = btnText.innerText;
    btnText.innerText = "Đang tải...";

    const arrowIcon = this.querySelector(".icon-arrow");
    const spinner   = this.querySelector(".btn-spinner");

    if (arrowIcon) {
      arrowIcon.classList.add("hidden");
    }
    if (spinner) {
      spinner.classList.remove("hidden");
    }

    fetchLibraryImages(activeTabId, offset, (response) => {
      this.disabled = false;
      btnText.innerText = originalText;

      if (arrowIcon) {
        arrowIcon.classList.remove("hidden");
      }
      if (spinner) {
        spinner.classList.add("hidden");
      }

      if (response.success && response.data.html) {
        const grid = resultsContainer.querySelector(".library-grid");
        if (grid) {
          // Append the new images to the grid
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = response.data.html;
          const items = tempDiv.querySelectorAll(".library-item");
          items.forEach((item) => grid.appendChild(item));
        }

        // Re-bind Fancybox
        Fancybox.bind('[data-fancybox="gallery-library"]', {
          groupAll: false,
        });

        // Update offset and toggle button visibility
        if (response.data.has_more) {
          this.classList.remove("hidden");
          this.dataset.offset = offset + 18;
        } else {
          this.classList.add("hidden");
        }
      }
    });
  });

  // Fetch helper
  function fetchLibraryImages(tabId, offset, callback) {
    const ajaxUrl =
      typeof window.hdConfig !== "undefined"
        ? window.hdConfig._ajaxUrl
        : "/wp-admin/admin-ajax.php";
    const nonce =
      typeof window.hdConfig !== "undefined" ? window.hdConfig._csrfToken : "";

    const params = new URLSearchParams({
      action: "get_photo_library",
      tab_id: tabId,
      page_id: pageId,
      offset: offset,
      limit: 18,
      _wpnonce: nonce,
    });

    fetch(ajaxUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params.toString(),
    })
      .then((response) => response.json())
      .then((data) => callback(data))
      .catch((err) => {
        console.error("AJAX Error:", err);
        callback({ success: false });
      });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLibrary);
} else {
  initLibrary();
}
